import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

import Loader from '../../components/Common/Loader';
import DmxDeviceProfileList from '../../components/Lists/DmxDeviceProfileList';
import { getDmxProfiles } from '../../store/actions';

class DmxDeviceProfiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      profileList: null,
    };
  }

  componentDidMount() {
    this.props.getDmxProfiles(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.profiles !== prevProps.profiles) {
      this.setState({ profileList: this.props.profiles });
    }
  }

  refresh(event) {
    event.preventDefault();
    this.setState({ profileList: null });
    this.props.getDmxProfiles(this.state.user);
  }

  render() {
    if (!this.state.profileList) {
      return (
        <div className="loaderCenter">
          <Loader></Loader>
        </div>
      );
    }
    return (
      <div className="user-management">
        <Container fluid>
          <Button
            onClick={(event) => this.refresh(event)}
            color="primary"
            className="btn btn-primary buttonStatus usersButtons"
          >
            <i size="lg" className="mdi mdi-refresh"></i>
          </Button>
          <Button className="btn btn-primary waves-effect waves-light buttonStatus usersButtons">
            <Link to="/createDmxDeviceProfile">{this.props.t('Crear perfil')}</Link>
          </Button>
          <DmxDeviceProfileList profileList={this.state.profileList} />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { profiles } = state.getDmxProfiles;
  return { profiles };
};

export default withRouter(connect(mapStateToProps, { getDmxProfiles })(withNamespaces()(DmxDeviceProfiles)));
